<template>
    <div>
        <div
            v-for="(msgGrp, index) in messageGroups"
            :key="msgGrp.sender.title+String(index)"
            class="chat"
            :class="{'chat-left': isLeftSide(msgGrp)}"
        >
            <div class="chat-body">
                <div :class="{'text-right': !isLeftSide(msgGrp), sender: true}">
                    <u><strong>{{ msgGrp.sender.title }}</strong></u>
                </div>
                <div
                    v-for="msgData in msgGrp.messages"
                    :key="msgData.id"
                    class="chat-message"
                >
                    <div class="chat-content bg-light">
                        <p>{{ msgData.message }}</p>
                        <small class="text-muted">{{ msgData.sentAt|moment('Y-MM-DD HH:mm:ss') }}</small>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="messageGroups.length === 0" class="d-flex justify-content-center text-center align-items-center">
            {{ $t('Component(Conversation):no-messages') }}
        </div>
    </div>
</template>

<script>
import {BAvatar} from 'bootstrap-vue'

export default {
    components: {
        BAvatar,
    },
    props: {
        chat: {
            type: Object,
            required: true
        },
        messages: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            messageGroups: this.makeMessageGroups(this.messages),
        };
    },
    methods: {
        isLeftSide(message) {
            return this.chat.subscriber.id === message.sender.id;
        },
        makeMessageGroups(messages) {
            let groups = [];
            let sender = messages.length > 0 ? messages[0].sender : undefined;
            let group = {
                sender: sender,
                messages: []
            };

            messages.forEach((message, index) => {
                if (sender.id === message.sender.id) {
                    group.messages.push(message);
                } else {
                    sender = message.sender;
                    groups.push(group);
                    group = {
                        sender: message.sender,
                        messages: [message]
                    };
                }

                if (index === this.messages.length - 1) {
                    groups.push(group);
                }
            });

            return groups;
        }
    },
    watch: {
        chat(chat) {

        },
        messages(messages) {
            this.messageGroups = this.makeMessageGroups(messages);
        }
    },
}
</script>

<style scoped lang="scss">
.chat-body {
    margin: 0 !important;
}
.chat {
    text-align: right;
    padding-bottom: 6px;

    .chat-message {
        margin-bottom: 1rem;
    }

    .sender {
        margin-bottom: 1rem;
    }
}
.chat.chat-left {
    text-align: left;
}
.chat .chat-content {
    border: 1px solid #f6f6f6 !important;
    padding: 1rem;
    display: inline-block;
}
</style>
